import { render, staticRenderFns } from "./EditTip.vue?vue&type=template&id=64835839&lang=pug"
import script from "./EditTip.vue?vue&type=script&lang=js"
export * from "./EditTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports